import { z } from "zod";

// about-us-navigation
export type AboutUsNavigation = z.output<typeof AboutUsNavigationSchema>;
export const AboutUsNavigationSchema = z.object({
  label: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),
  downloadCta: z.string()
});
// blog-navigation
export type BlogNavigation = z.output<typeof BlogNavigationSchema>;
export const BlogNavigationSchema = z.object({
  label: z.string(),
});

// faqs-navigation
export type FaqsNavigation = z.output<typeof FaqsNavigationSchema>;
export const FaqsNavigationSchema = z.object({
  label: z.string(),
  link1: z.string(),
  link2: z.string(),
});

// shops-navigation
export type ShopsNavigation = z.output<typeof ShopsNavigationSchema>;
export const ShopsNavigationSchema = z.object({
  label: z.string(),
  mainLink: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),
  loginCta: z.string(),
  becomePartnerCta: z.string(),
});


// travelers-navigation
export type TravelersNavigation = z.output<typeof TravelersNavigationSchema>;
export const TravelersNavigationSchema = z.object({
  label: z.string(),
  mainLink: z.string(),
  link1: z.string(),
  link2: z.string(),
  link3: z.string(),
  link4: z.string(),
  link5: z.string(),
  downloadCta: z.string()
});
